var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7188 8.75C17.7188 13.1094 14.5195 16.7305 10.3359 17.3633V11.2812H12.375L12.7617 8.75H10.3359V7.13281C10.3359 6.42969 10.6875 5.76172 11.7773 5.76172H12.8672V3.61719C12.8672 3.61719 11.8828 3.44141 10.8984 3.44141C8.92969 3.44141 7.62891 4.67188 7.62891 6.85156V8.75H5.41406V11.2812H7.62891V17.3633C3.44531 16.7305 0.28125 13.1094 0.28125 8.75C0.28125 3.93359 4.18359 0.03125 9 0.03125C13.8164 0.03125 17.7188 3.93359 17.7188 8.75Z",
    fill: "#007BF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.492a3a0aae1847402aea9f3aa1251acd.svg";
export { ForwardRef as ReactComponent };